<div *ngIf="data.type === 'message'">
    <h2 mat-dialog-title>{{data.title | translate}}</h2>
    <mat-dialog-content class="mat-typography">
        {{data.text | translate}}
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>{{'MESSAGE.CANCEL' | translate}}</button>
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{'MESSAGE.CONFIRM' | translate}}</button>
    </mat-dialog-actions>
</div>


<div *ngIf="data.type === 'combination'">
    <mat-icon class="close-button" [mat-dialog-close]="true">close</mat-icon>
    <h2 mat-dialog-title>{{'TOTESYSTEM.COMBINATIONS' | translate}}</h2>
    <mat-dialog-content class="mat-typography">
        <div *ngIf="cartService.cartSystem.sco.length > 0"
             [ngClass]="{'acc': cartService.cartSystem.sco[0].cod === 7 || cartService.cartSystem.sco[0].cod === 8, 'trio': cartService.cartSystem.sco[0].cod === 9 || cartService.cartSystem.sco[0].cod === 10}">
            <div class="d-flex justify-content-between div-comb-label" *ngIf="cartService.cartSystem.sco[0].cod === 8 || cartService.cartSystem.sco[0].cod === 10">
                <div class="label-comb">{{'TICKETS.FIRST' | translate}}</div>
                <div class="label-comb">{{'TICKETS.SECOND' | translate}}</div>
                <div class="label-comb" *ngIf="cartService.cartSystem.sco[0].cod === 10">{{'TICKETS.THIRD' | translate}}</div>
                <div>{{'TICKETS.ODD' | translate}}</div>
                <div>{{'TICKETS.WINNING' | translate}}</div>
            </div>
            <div class="d-flex justify-content-between div-comb-label" *ngIf="cartService.cartSystem.sco[0].cod === 7 || cartService.cartSystem.sco[0].cod === 9">
                <div *ngIf="responsiveService.fullSize.matches" class="label-comb">{{'TICKETS.FIRST' | translate}} - {{'TICKETS.SECOND' | translate}} <span *ngIf="cartService.cartSystem.sco[0].cod === 9"> - {{'TICKETS.THIRD' | translate}}</span></div>
                <div *ngIf="responsiveService.fullSize.matches" class="label-comb">{{'TICKETS.FIRST' | translate}} - {{'TICKETS.SECOND' | translate}} <span *ngIf="cartService.cartSystem.sco[0].cod === 9"> - {{'TICKETS.THIRD' | translate}}</span></div>
                <div class="label-comb" *ngIf="cartService.cartSystem.sco[0].cod === 9 && responsiveService.fullSize.matches">{{'TICKETS.FIRST' | translate}} - {{'TICKETS.SECOND' | translate}} - {{'TICKETS.THIRD' | translate}}</div>

                <div *ngIf="responsiveService.extraSmallSize.matches" class="label-comb">1 - 2<span *ngIf="cartService.cartSystem.sco[0].cod === 9"> - 3</span></div>
                <div *ngIf="responsiveService.extraSmallSize.matches" class="label-comb">1 - 2<span *ngIf="cartService.cartSystem.sco[0].cod === 9"> -3</span></div>
                <div class="label-comb" *ngIf="cartService.cartSystem.sco[0].cod === 9 && responsiveService.extraSmallSize.matches">1- 2 - 3</div>

                <div>{{'TICKETS.ODD' | translate}}</div>
                <div>{{'TICKETS.WINNING' | translate}}</div>
            </div>
            <div class="d-flex justify-content-between div-comb" *ngFor="let comb of cartService.cartSystem.sco[0].comb" [ngClass]="{'bg-success text-white': checkQuotaMigliore(comb.qm)}">
                <div class="label-comb" *ngFor="let combin of comb.combin">{{combin.c}}</div>
                <div>{{comb.qm/100 | number: '1.2-2'}}</div>
                <div>{{(comb.qm/100 * (cartService.cartSystem.pun/cartService.cartSystem.sco[0].cb))/100 | number: '1.2-2'}} {{data.symbol}}</div>
            </div>
        </div>
    </mat-dialog-content>
</div>


<div *ngIf="data.type === 'acc_top'">
    <mat-icon class="close-button" [mat-dialog-close]="true">close</mat-icon>
    <div mat-dialog-title>
        <div class="div-race-name-inner">
            <div class="country-icon">
                <mat-icon class="mr-1" *ngIf="data.race.countryid" svgIcon="{{data.race.countryid}}"></mat-icon>
                {{ ('MENU.' + data.race.country | uppercase) | translate | uppercase}}
            </div>
            <div>
                <mat-icon class="mr-1" svgIcon="{{data.race.tp | uppercase}}"></mat-icon>
                <span *ngIf="data.race.countryid === '112'">{{data.race.course | uppercase}}</span>
                <span *ngIf="data.race.countryid !== '112'">{{data.race.course}}</span>
            </div>
            <div>{{data.text | translate}}</div>
        </div>
    </div>
    <mat-dialog-content class="dialog-acctrio">
        <div class="d-flex mt-2 mb-2 justify-content-between">
            <div class="qt-migliori" style="flex-wrap: wrap;">
                <h5 class="w-100">{{'GENERAL.BEST' | translate}}</h5>
                <div class="d-flex">
                    <div>
                        <div *ngFor="let quote of data.qAcc.best index as i">
                            <div *ngIf="i <= 11" class="d-flex">
                                <button mat-button [disabled]="true">{{quote.combin[0].c}} - {{quote.combin[1].c}}<span *ngIf="quote.combin[2]"> - {{quote.combin[2].c}}</span></button>
                                <button mat-button class="btn-qfx" [ngClass]="{'btn-min-quote': i === 0}" (click)="addBet(quote,data.qAcc.scommessa)">
                                    {{quote.qm/100 | number : '1.2-2'}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div *ngFor="let quote of data.qAcc.best index as i">
                            <div *ngIf="i > 11 && i <= 23" class="d-flex">
                                <button mat-button [disabled]="true">{{quote.combin[0].c}} - {{quote.combin[1].c}}<span *ngIf="quote.combin[2]"> - {{quote.combin[2].c}}</span></button>
                                <button mat-button class="btn-qfx" (click)="addBet(quote,data.qAcc.scommessa)">
                                    {{quote.qm/100 | number : '1.2-2'}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div *ngFor="let quote of data.qAcc.best index as i">
                            <div *ngIf="i > 23 && i <= 35" class="d-flex">
                                <button mat-button [disabled]="true">{{quote.combin[0].c}} - {{quote.combin[1].c}}<span *ngIf="quote.combin[2]"> - {{quote.combin[2].c}}</span></button>
                                <button mat-button class="btn-qfx" (click)="addBet(quote,data.qAcc.scommessa)">
                                    {{quote.qm/100 | number : '1.2-2'}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="qt-peggiori">
                <h5>{{'GENERAL.WORST' | translate}}</h5>
                <div *ngFor="let quote of data.qAcc.worst index as i">
                    <div *ngIf="i <= 12">
                        <button mat-button [disabled]="true">{{quote.combin[0].c}} - {{quote.combin[1].c}}<span *ngIf="quote.combin[2]"> - {{quote.combin[2].c}}</span></button>
                        <button mat-button class="btn btn-status" (click)="addBet(quote, data.qAcc.scommessa)">
                            {{quote.qm/100 | number : '1.2-2'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>

</div>
